import { Input, NumberInput } from '@/components/ui';
import { TRDData } from './ModifySchoolParameters';

interface TRDParamsProps {
  trdData: TRDData;
  handleOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const TRDParams = ({ trdData, handleOnChange }: TRDParamsProps) => {
  return (
    <>
      <h3 className="text-sh3 font-bold text-primary-black-90">Teaching related duties (TRD)</h3>
      <dl
        className="grid grid-cols-[max-content_1fr] items-center gap-x-5 gap-y-3 text-b2 text-b3 text-secondary-grey-02
          [grid-auto-rows:75px]"
      >
        <dt className="font-bold">Marking</dt>
        <dd className="flex items-center gap-2">
          <NumberInput
            value={trdData.trdMarkingHours}
            className="h-[30px] w-[117px] border-secondary-grey-04 text-b2"
            data-category="trd"
            data-key="trdMarkingHours"
            onChange={handleOnChange}
            decimalScale={2}
            min={0}
          />
          Hours per student
        </dd>

        <dt className="font-bold">Preparation</dt>
        <dd className="flex items-center gap-2">
          <NumberInput
            className="h-[30px] w-[117px] border-secondary-grey-04 text-b2"
            min={0}
            value={trdData.trdPreparationHours}
            data-category="trd"
            data-key="trdPreparationHours"
            onChange={handleOnChange}
            decimalScale={2}
          />
          Hours per teaching week
        </dd>

        <dt className="font-bold">Consultation</dt>
        <dd className="flex items-center gap-2">
          <NumberInput
            className="h-[30px] w-[117px] border-secondary-grey-04 text-b2"
            min={0}
            value={trdData.trdConsultationHours}
            data-category="trd"
            data-key="trdConsultationHours"
            onChange={handleOnChange}
            decimalScale={2}
          />
          Hours per teaching week
        </dd>

        <dt className="font-bold">Moderation</dt>
        <dd className="flex items-center gap-2">
          <NumberInput
            className="h-[30px] w-[117px] border-secondary-grey-04 text-b2"
            min={0}
            value={trdData.trdModerationHours}
            data-category="trd"
            data-key="trdModerationHours"
            onChange={handleOnChange}
            decimalScale={2}
          />
          Hours per unit
        </dd>
      </dl>
    </>
  );
};
